import assest from "@/json/assest";
import Wrapper from "@/layout/wrapper/Wrapper";
import { Button, Grid, Typography } from "@mui/material";
import { Box, Container, styled } from "@mui/system";
import Image from "next/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CommonHeaderInner from "@/components/CommonHeaderInner/CommonHeaderInner";
import WhatPeopleSay from "@/components/WhatPeopleSay/WhatPeopleSay";
import Seo from "@/components/Seo/Seo";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useNotiStack from "@/hooks/useNotistack";

import validationText from "@/json/messages/validationText";

import { Controller, SubmitHandler, useForm } from "react-hook-form";

import CustomInput from "@/ui/Inputs/CustomInput";
import axios from "axios";
import CustomButton from "@/ui/Buttons/CustomButton";
import { useState } from "react";
const ContactSec = styled(Box)`
  .contact-inr {
    padding-right: 40px;
    @media (max-width: 599px) {
      padding-right: 0px;
    }
    .text_center_heading {
      text-align: center;
      max-width: 756px;
      width: 100%;
      margin: 0px auto 30px;
    }
    .btn-outr {
      margin-top: 25px;
      .MuiTypography-root {
        display: inline-flex;
        align-items: center;
        span {
          margin-right: 24px;
        }
      }
    }
    li {
      margin-bottom: 30px;
      &.MuiListItem-root {
        padding: 0;
        background-image: url("/assets/images/tick-grn.svg");
        background-position: center left;
        padding-left: 47px;
        background-repeat: no-repeat;
        background-size: 33px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .contact-form {
    background: #ffffff;
    box-shadow: 0px -6px 64px rgba(0, 0, 0, 0.05);
    border-radius: 15px;
    padding: 40px 50px;
    @media (max-width: 599px) {
      padding: 20px;
    }
    .MuiFormControl-root {
      width: 100%;
      margin: 10px 0;
      @media (max-width: 599px) {
        margin: 5px 0;
      }
      input {
        background: #ffffff;
        border-radius: 10px;
        cursor: pointer;
      }
      textarea {
        height: 187px !important;
        cursor: pointer;
      }
      fieldset {
        legend {
          background: #fff !important;

          span {
            color: #66666645 !important;
            background: #fff !important;
          }
        }
      }
      .MuiInputLabel-root {
        /* transform: translate(14px, 18px) scale(1); */
        color: #65676a;
        font-weight: 400;
        font-size: 16px;
        padding-top: 8px;

        /* &.Mui-focused {
        transform: translate(14px, -9px) scale(0.75);
      } */
        &.MuiInputLabel-shrink {
          padding-top: 0;
        }
      }
      .Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border-color: rgba(0, 0, 0, 0.23);
          border-width: 1px;
        }
      }
    }
    .full_btn {
      /* background: #1e294c;
      border-radius: 50px;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #ffffff;
      width: 100%;
      padding: 20px 0; */
      margin: 40px 0 0 0;
      /* border: 1px solid #1e294c; */
      @media (max-width: 599px) {
        margin: 10px 0 0 0;
      }
      /* &:hover {
        border: 1px solid #1e294c;
        color: #1e294c;
        background: transparent;
      } */
    }
  }
`;

const MapSec = styled(Box)`
  .contact_map_sec {
    margin: 0 0 100px 0;
    @media (max-width: 899px) {
      margin-bottom: 50px;
    }
    .MuiGrid-root {
      .map {
        border-radius: 10px;
        border: 1px solid #fff;
        width: 100%;
        height: 260px;
        max-width: 100%;
      }
    }
    .MuiList-root {
      padding: 0;
      .MuiListItem-root {
        display: flex;
        padding: 0;
        &:not(:last-child) {
          margin-bottom: 35px;
        }
        .contact_fig {
          border-right: 1px solid rgba(0, 0, 0, 0.5);
          padding: 0 10px 0 0;
          margin: 0 10px 0 0;
          display: flex;
          align-items: center;
        }
        p,
        a {
          font-weight: 400;
          font-size: 16px;
          line-height: 23px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
`;
//=== TYPES ====
interface IFormInput {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const schema = yup.object().shape({
  email: yup
    .string()
    .email(validationText.error.email_format)
    .required(validationText.error.enter_email),
  name: yup.string().required(validationText.error.name),
  subject: yup.string().required(validationText.error.subject),
  message: yup.string().required(validationText.error.message),
});

export default function contact() {
  const { toastSuccess, toastError } = useNotiStack();
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    control,
    register,
    reset,
    formState: { errors },
  } = useForm<IFormInput>({
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    // =====>sendgrid<=====

    // axios
    //   .post("/api/sendgrid", {
    //     name: data.name,
    //     email: data.email,
    //     message: data.message,
    //     subject: data.subject,
    //   })
    //   .then((res) => {
    //     console.log(res, "res");
    //     // reset();
    //     // if (res.status === 200) {
    //     //   toastSuccess("success");
    //     // } else {
    //     //   toastSuccess("success");
    //     // }
    //   })
    //   .catch((err) => {
    //     console.log(err, "err");
    //     toastError(err?.message);
    //   });

    //  =====>Nodemailer<=====

    setIsLoading(true);
    fetch("/api/sendgrid", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (res.status === 200) {
           toastSuccess("Message sent successfully");
          reset();
          setIsLoading(false);
        } else {
          // setIsLoading(false);
        }
      })
      .catch((err) => {
        toastError(err?.message);
        setIsLoading(false);
      });
  };
  return (
    <Wrapper>
      <Seo
        title="Contact"
        canonical={""}
        description={""}
        url={""}
        image={""}
      />
      <CommonHeaderInner name="Contact" pageName="Contact" />
      <ContactSec>
        <Box className="contact-sec-main cmn_gap">
          <Box className="contact-sec">
            <Container fixed>
              <Box className="contact-outr">
                <Grid container spacing={2} className="contact-row">
                  <Grid item md={12}>
                    <Box className="contact-inr">
                      <Box className="text_center_heading">
                        <Typography variant="h2" className="cmn-head">
                          Get in touch with <span>Us</span>
                        </Typography>
                        <Typography variant="body1">
                          Feel free to request for more information and send in
                          your questions and other concerns by completing the
                          following form.
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="contact-form">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Typography variant="h2" className="cmn-head">
                          Get in touch
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid item md={6} xs={12}>
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              variant="outlined"
                              {...register("name")}
                              className={
                                errors?.name?.message
                                  ? "formRootHide"
                                  : "newFormRoot"
                              }
                            />
                            <span className="errormesg">
                              {errors?.name?.message}
                            </span>
                            <TextField
                              id="outlined-basic"
                              label="Email"
                              variant="outlined"
                              {...register("email")}
                              className={
                                errors?.email?.message
                                  ? "formRootHide"
                                  : "newFormRoot"
                              }
                            />
                            <span className="errormesg">
                              {errors?.email?.message}
                            </span>
                            <TextField
                              id="outlined-basic"
                              label="Subject"
                              variant="outlined"
                              {...register("subject")}
                              className={
                                errors?.subject?.message
                                  ? "formRootHide"
                                  : "newFormRoot"
                              }
                            />
                            <span className="errormesg">
                              {errors?.subject?.message}
                            </span>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              label="Message"
                              multiline
                              rows={4}
                              {...register("message")}
                              className={
                                errors?.message?.message
                                  ? "formRootHide"
                                  : "newFormRoot"
                              }
                            />
                            <span className="errormesg">
                              {errors?.message?.message}
                            </span>
                          </Grid>
                        </Grid>
                        <Box className="full_btn">
                          <CustomButton
                            loading={isLoading}
                            type="submit"
                            disabled={false}
                            fullWidth={true}
                          >
                            <span>Send Message</span>
                          </CustomButton>
                        </Box>
                      </form>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Box>
      </ContactSec>

      <MapSec>
        <Box className="contact-sec-main">
          <Box className="contact-sec">
            <Container fixed>
              <Box className="contact-outr">
                <Box className="contact_map_sec">
                  <Grid container spacing={2} className="contact-row">
                    <Grid item md={6} xs={12} className="order2">
                      <Typography variant="h2" className="cmn-head">
                        Our location
                      </Typography>
                      <List>
                        <ListItem>
                          <figure className="contact_fig">
                            <Image
                              src={assest.location}
                              alt="location"
                              width={20}
                              height={26}
                            />
                          </figure>
                          <Typography variant="body1">
                            6094 Franconia Rd,Suite A, Alexandria, VA 22310
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <figure className="contact_fig">
                            <Image
                              src={assest.mail}
                              alt="location"
                              width={20}
                              height={26}
                            />
                          </figure>
                          <Typography variant="body1">
                            <a href="mailto:info@aaaresidencies.com">
                              info@aaaresidencies.com
                            </a>
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <figure className="contact_fig">
                            <Image
                              src={assest.call}
                              alt="location"
                              width={20}
                              height={26}
                            />
                          </figure>
                          <Typography variant="body1">
                            <a href="tel:+7033362018">703-336-2018</a>
                          </Typography>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item md={6} xs={12} className="order1">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24880.805596247104!2d-77.1507372!3d38.7843258!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b27d0584a713%3A0xa0bd79bf1ac6afb3!2s6094%20Franconia%20Rd%2C%20Franconia%2C%20VA%2022310%2C%20USA!5e0!3m2!1sen!2sin!4v1678777680905!5m2!1sen!2sin"
                        width={100}
                        height={250}
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />

                      {/* <iframe src=" https://www.google.com/maps/place/6094+Franconia+Rd,+Franconia,+VA+22310,+USA/@38.7843258,-77.1507372,14.66z/data=!4m6!3m5!1s0x89b7b27d0584a713:0xa0bd79bf1ac6afb3!8m2!3d38.7828258!4d-77.1463181!16s%2Fg%2F11fnj7nvxk" className="map" loading="lazy">
                     </iframe>  */}
                      {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14736.281053276303!2d88.4306861!3d22.57647525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1678256035659!5m2!1sen!2sin" className="map" loading="lazy">

                      */}
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Container>
          </Box>
        </Box>
      </MapSec>
    </Wrapper>
  );
}
